export const mobileBreakpoint = 768;
export const tabletBreakpoint = 992;
export const thiccBreakpoint = 1920;

export const mobileQuery = `@media (max-width: ${mobileBreakpoint}px)`;
export const tabletQuery = `@media (max-width: ${tabletBreakpoint}px)`;
export const thiccQuery = `@media (max-width: ${thiccBreakpoint}px)`;
